// src/components/Hero.js
import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="company">
      <div className="hero-content">
        <h2>
          We<br />
          develop<br />
          computational solutions based<br />
          on sound mathematics
        </h2>
        <p>so you may enjoy a more <span className="highlight">E2e</span> life.</p>
      </div>
    </section>
  );
}

export default Hero;